import "./LandingPageHeading.css";

const LandingPageHeading = () => {
  return (
    <h1 className="bold landing-page__heading">
      Nasza firma oferuje najwyższej jakości produkty.
    </h1>
  );
};
export default LandingPageHeading;
